var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4253.11,-2.42969 H -1.10938 V 4252 H 4253.11 V -2.42969",
    style: {
      fill: "#3678c0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 564.738,3895.25 V 3037.84 H 420.551 v 656.32 h -1.258 L 318.168,3589.22 h -1.316 v 150.48 l 132.781,155.55 h 115.105",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 739.34,3289.42 129.062,352.99 h 1.27 v -352.99 z m 264.45,-251.77 v 139.15 h 58.19 v 112.62 h -58.19 v 606.02 H 862.074 L 612.848,3265.38 v -88.58 h 254.297 v -139.15 h 136.645",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2662.19,1083.14 c -78.17,0 -141.52,63.44 -141.52,141.58 0,78.13 63.35,141.41 141.52,141.41 78.36,0 141.69,-63.28 141.69,-141.41 0,-78.14 -63.33,-141.58 -141.69,-141.58 m 614.66,65.95 c -53.55,72.35 -399.39,513.28 -884.26,513.28 -421.05,0 -871.48,-381.9 -871.48,-381.9 0,0 -169.21,346.31 -515.31,379.58 -2.04,0 -4.2,0.46 -6.507,0.46 h -2.141 c -7.226,-0.4 -13.996,-7.42 -13.214,-13.7 0.98,-6.07 5.421,-12.67 5.421,-12.67 44.611,-74.06 158.461,-284.78 158.461,-495.29 0,-211.202 -114.53,-422.479 -158.722,-496.19 l -2.993,-4.699 c -1.296,-2.231 -2.167,-4.441 -2.167,-7.301 0,-7.308 5.675,-12.988 12.777,-13.64 l 3.735,0.308 c 1.17,0 2.41,0 3.65,0.344 347.18,32.348 517.01,379.707 517.01,379.707 0,0 450.43,-381.93 871.48,-381.93 484.87,0 830.71,440.951 884.26,513.131 1.46,1.97 2.66,3.67 3.71,4.97 0.63,1.69 1.13,3.27 1.13,5.3 0,1.89 -0.5,3.81 -1.13,5.28 -1.05,1.47 -2.25,3.16 -3.71,4.96",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 994.887,2491.15 c -1.067,0.24 -1.785,0.6 -2.664,0.6 -7.668,0 -13.918,-6.26 -13.918,-14.06 v -96.51 c 0,-4.03 1.523,-7.58 4.05,-9.99 234.065,-203.37 455.675,-12.81 506.975,37.54 1.05,1.53 2.14,3 3.66,3.93 2.31,1.47 4.81,2.52 7.67,2.52 3.61,0 7.02,-1.4 9.42,-3.73 0.19,-0.27 0.47,-0.48 0.68,-0.6 264.39,-252.32 541.61,-47.96 599.28,0 l 5.69,5.19 c 1.62,0.76 3.38,1.05 5.26,1.05 1.96,0 3.93,-0.29 5.5,-1.05 l 5.71,-5.19 c 57.65,-47.96 334.87,-252.32 599.24,0 0.05,0.12 0.38,0.33 0.51,0.6 2.48,2.33 5.73,3.73 9.4,3.73 2.86,0 5.52,-1.05 7.67,-2.52 1.6,-0.93 2.7,-2.4 3.89,-3.93 51.25,-50.35 272.63,-240.91 506.9,-37.54 2.42,2.41 4.02,5.96 4.02,9.99 v 96.51 c 0,7.8 -6.06,14.06 -13.73,14.06 -1,0 -1.93,-0.36 -3,-0.6 -2.16,-1.24 -4.41,-2.4 -7.02,-3.64 -71.98,-36.06 -295.24,-121.82 -497.91,69.91 -1.9,1.79 -3.89,3.57 -5.89,5.64 -1.85,0.76 -3.63,1.26 -5.91,1.26 -1.41,0 -2.93,-0.4 -4.17,-0.65 -3.02,-1.21 -5.42,-3.13 -7.06,-5.46 -60.41,-46.05 -337.63,-233.74 -584.52,-3.43 l -3.61,3.52 c -2.58,2.29 -6.09,4.16 -10.02,4.16 -3.64,0 -7.26,-1.87 -9.65,-4.16 l -3.85,-3.52 c -246.76,-230.31 -524.29,-42.62 -584.6,3.43 -1.58,2.33 -3.9,4.25 -6.87,5.46 -1.42,0.25 -2.83,0.65 -4.41,0.65 -1.97,0 -3.93,-0.5 -5.82,-1.26 -1.8,-2.07 -3.94,-3.85 -5.93,-5.64 -202.64,-191.73 -425.82,-105.97 -497.85,-69.91 -2.533,1.24 -4.936,2.4 -7.123,3.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1489.33,2057.6 c 1.11,1.57 2.14,2.73 3.69,3.83 2.28,1.42 4.81,2.61 7.64,2.61 3.61,0 7.05,-1.47 9.48,-3.87 0.13,-0.24 0.41,-0.43 0.62,-0.6 264.31,-251.97 541.61,-47.73 599.31,0 l 5.66,5.39 c 1.62,0.65 3.38,0.88 5.24,0.88 2.01,0 3.92,-0.23 5.58,-0.88 l 5.65,-5.39 c 57.65,-47.73 334.84,-251.97 599.26,0 0.06,0.17 0.28,0.36 0.49,0.6 2.48,2.4 5.71,3.87 9.37,3.87 2.92,0 5.55,-1.19 7.67,-2.61 1.65,-1.1 2.73,-2.26 3.92,-3.83 51.22,-50.41 272.61,-241.04 506.9,-37.46 2.45,2.49 4.1,5.75 4.1,9.77 v 96.76 c 0,7.71 -6.19,13.85 -13.81,13.85 -1,0 -1.93,-0.38 -3,-0.58 -2.16,-1.04 -4.44,-2.26 -7.02,-3.51 -71.92,-36.1 -295.29,-121.65 -497.91,69.83 -1.88,1.81 -3.87,3.62 -5.86,5.57 -1.88,1.04 -3.66,1.38 -5.94,1.38 -1.41,0 -2.91,-0.34 -4.17,-1.05 -3.05,-0.76 -5.42,-2.69 -7.06,-5.19 -60.36,-45.97 -337.63,-233.72 -584.54,-3.39 l -3.62,3.61 c -2.55,2.47 -6.09,3.88 -10.01,3.88 -3.62,0 -7.24,-1.41 -9.66,-3.88 l -3.82,-3.61 c -246.76,-230.33 -524.29,-42.58 -584.6,3.39 -1.58,2.5 -3.92,4.43 -6.84,5.19 -1.42,0.71 -2.92,1.05 -4.44,1.05 -1.99,0 -3.9,-0.34 -5.76,-1.38 -1.91,-1.95 -3.95,-3.76 -6.01,-5.57 -202.64,-191.48 -425.8,-105.93 -497.83,-69.83 -2.533,1.25 -4.905,2.47 -7.104,3.51 -1.086,0.2 -1.789,0.58 -2.656,0.58 -7.695,0 -13.945,-6.14 -13.945,-13.85 v -96.76 c 0,-4.02 1.523,-7.28 4.023,-9.77 234.092,-203.58 455.722,-12.95 507.002,37.46",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1399.93,3905.38 h 60.41 v -310.02 h 72.07 v -49.29 h -132.48 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1557.33,3905.38 h 144.14 v -49.29 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.16 h 83.73 v -49.29 h -144.14 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1791.59,3707.71 v -112.35 h 26.48 c 20.15,0 29.69,10.07 29.69,29.14 v 54.06 c 0,19.08 -9.02,29.15 -30.22,29.15 z m 0,46.1 h 21.19 c 19.61,0 28.61,10.07 28.61,29.14 v 44 c 0,19.6 -9,29.14 -29.14,29.14 h -20.66 z m -60.42,151.57 h 87.44 c 60.42,0 80.55,-28.09 80.55,-78.97 v -36.56 c 0,-30.21 -11.13,-49.29 -36.03,-57.24 30.19,-6.88 45.04,-27.02 45.04,-59.88 v -47.7 c 0,-50.87 -22.8,-78.96 -83.21,-78.96 h -93.79 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1935.75,3905.38 h 144.14 v -49.29 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.16 h 83.73 v -49.29 h -144.14 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2160.45,3771.83 v -225.76 h -50.88 v 359.31 h 59.36 l 65.19,-206.15 v 206.15 h 50.34 v -359.31 h -52.99 l -71.02,225.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2544.69,3905.38 v -271.86 c 0,-55.64 -23.85,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.04 -90.09,91.68 v 271.86 h 60.41 v -277.69 c 0,-21.21 8.48,-35.51 29.68,-35.51 21.2,0 29.68,14.3 29.68,35.51 v 277.69 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2627.38,3771.83 v -225.76 h -50.87 v 359.31 h 59.35 l 65.18,-206.15 v 206.15 h 50.35 v -359.31 h -53.01 l -71,225.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2776.31,3905.38 h 160.57 v -49.29 h -49.81 v -310.02 h -60.94 v 310.02 h -49.82 v 49.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2962.33,3905.38 h 144.15 v -49.29 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.16 h 83.73 v -49.29 h -144.15 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3196.59,3856.09 v -111.82 h 20.13 c 20.67,0 29.67,10.59 29.67,29.68 v 53 c 0,19.6 -9,29.14 -29.67,29.14 z m 0,-145.21 v -164.81 h -60.42 v 359.31 h 87.96 c 60.95,0 83.21,-30.21 83.21,-80.56 v -46.11 c 0,-38.68 -13.78,-61.46 -48.23,-69.41 l 57.77,-163.23 h -63.6 l -56.69,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1530.3,3268.12 -33.93,-222.04 h -56.7 l -48.22,359.3 h 58.29 l 28.09,-227.88 h 0.53 l 30.2,227.88 h 49.3 l 33.37,-227.88 h 0.53 l 27.56,227.88 h 50.88 l -46.64,-359.3 h -57.23 l -35.51,222.04 h -0.52",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1738.59,3160.01 h 48.22 l -23.85,144.14 h -0.52 z m -75.78,-113.93 67.83,359.3 h 68.9 l 68.35,-359.3 h -62.01 l -11.12,65.71 h -64.12 l -10.6,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1881.69,3123.45 v 48.22 h 56.18 v -49.29 c 0,-20.13 9.01,-31.79 29.67,-31.79 19.08,0 27.56,12.71 27.56,31.79 v 13.78 c 0,20.67 -8.48,33.39 -27.03,50.87 l -35.51,35.51 c -34.43,33.92 -50.33,54.59 -50.33,95.92 v 12.18 c 0,44.53 25.96,78.97 84.79,78.97 60.41,0 84.25,-29.68 84.25,-81.61 v -29.15 h -55.11 v 31.27 c 0,20.66 -9.54,30.74 -28.62,30.74 -16.95,0 -28.61,-9.54 -28.61,-29.68 v -7.42 c 0,-20.13 11.13,-31.8 28.61,-48.75 l 38.69,-38.16 c 32.86,-33.38 48.75,-53.52 48.75,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.96,-84.26 -61.48,0 -85.33,34.44 -85.33,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2078.32,3123.45 v 48.22 h 56.18 v -49.29 c 0,-20.13 9.01,-31.79 29.68,-31.79 19.08,0 27.56,12.71 27.56,31.79 v 13.78 c 0,20.67 -8.48,33.39 -27.03,50.87 l -35.51,35.51 c -34.44,33.92 -50.34,54.59 -50.34,95.92 v 12.18 c 0,44.53 25.97,78.97 84.8,78.97 60.41,0 84.25,-29.68 84.25,-81.61 v -29.15 h -55.11 v 31.27 c 0,20.66 -9.54,30.74 -28.62,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.13 11.13,-31.8 28.62,-48.75 l 38.69,-38.16 c 32.86,-33.38 48.75,-53.52 48.75,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.96,-84.26 -61.49,0 -85.34,34.44 -85.34,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2280.79,3405.38 h 144.15 v -49.29 h -83.74 v -102.81 h 59.89 v -48.76 h -59.89 v -109.17 h 83.74 v -49.27 h -144.15 v 359.3",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2515.04,3356.09 v -111.82 h 20.14 c 20.66,0 29.67,10.59 29.67,29.68 v 53 c 0,19.6 -9.01,29.14 -29.67,29.14 z m 0,-145.21 v -164.8 h -60.42 v 359.3 h 87.97 c 60.95,0 83.2,-30.21 83.2,-80.56 v -46.11 c 0,-38.68 -13.77,-61.46 -48.22,-69.41 l 57.77,-163.22 h -63.6 l -56.7,164.8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe14);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-14.33dcc9145a619e2c9447430b58946030.svg";
export { ForwardRef as ReactComponent };